// src/constants/churchFeatures.js
export const CHURCH_FEATURES = {
  membership: {
    key: "membership",
    label: "Membership",
    description: "Manage church members and membership form data"
  },
  donations: {
    key: "donations",
    label: "Donation Portal",
    description: "Accept and manage online donations"
  },
  eventRequests: {
    key: "eventRequests",
    label: "Event Requests (Weddings, Baptisms, etc.)",
    description: "Allow users to submit event requests like weddings, baptisms, etc."
  }
};
